// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingDot_root__3md5M","bouncing-loader":"LoadingDot_bouncing-loader__Ib9g3"};